import React from 'react'
import { createRoot } from 'react-dom/client'
import { pageLanguage } from '../components/Data'
import { ThemeSwitch } from '../components/Footer/ThemeSwitch'

// <theme-switch>: light, as the system, dark. In the header of every page.
export class ThemeSwitchElement extends HTMLElement {
  connectedCallback () {
    createRoot(this).render(<ThemeSwitch lang={pageLanguage()} />)
  }
}
customElements.define('theme-switch', ThemeSwitchElement)
